 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"16b93416ca1bd2e4cb6713ddcd17b49c99505daa","1":"styles","4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-templates-404-js","6":"component---src-templates-account-addresses-js","7":"component---src-templates-account-giftlist-items-js","8":"component---src-templates-account-giftlist-orders-js","9":"component---src-templates-account-giftlists-js","10":"component---src-templates-account-home-js","11":"component---src-templates-account-orders-js","12":"component---src-templates-account-wishlist-js","13":"component---src-templates-actions-202603-haymags-js","14":"component---src-templates-actions-202603-pantonwire-js","15":"component---src-templates-actions-fromme-2023-js","16":"component---src-templates-actions-hay-2023-outdoor-js","17":"component---src-templates-actions-moebe-2023-bed-js","18":"component---src-templates-actions-muuto-2023-dining-js","19":"component---src-templates-actions-pf-2023-js","20":"component---src-templates-actions-showroom-js","21":"component---src-templates-actions-string-2023-elevate-js","22":"component---src-templates-actions-upnorth-5-y-js","23":"component---src-templates-actions-weekend-2023-js","24":"component---src-templates-brands-index-js","25":"component---src-templates-brands-item-js","26":"component---src-templates-cart-js","27":"component---src-templates-category-js","28":"component---src-templates-checkout-giftwrapping-js","29":"component---src-templates-checkout-guest-js","30":"component---src-templates-checkout-index-js","31":"component---src-templates-checkout-payment-js","32":"component---src-templates-checkout-shipping-js","33":"component---src-templates-checkout-status-js","34":"component---src-templates-contact-js","35":"component---src-templates-content-about-js","36":"component---src-templates-content-appointment-js","37":"component---src-templates-content-complaints-js","38":"component---src-templates-content-customer-of-the-month-js","39":"component---src-templates-content-delivery-js","40":"component---src-templates-content-payment-js","41":"component---src-templates-content-privacy-js","42":"component---src-templates-content-returns-js","43":"component---src-templates-content-string-byo-js","44":"component---src-templates-content-team-js","45":"component---src-templates-content-terms-js","46":"component---src-templates-content-testimonials-js","47":"component---src-templates-content-vacatures-js","48":"component---src-templates-content-vacatures-js-developer-js","49":"component---src-templates-createaccount-js","50":"component---src-templates-giftlist-buy-index-js","51":"component---src-templates-giftlist-create-index-js","52":"component---src-templates-giftlist-index-js","53":"component---src-templates-homepage-js","54":"component---src-templates-interioradvice-js","55":"component---src-templates-lostpassword-js","56":"component---src-templates-new-202603-hayterrazza-js","57":"component---src-templates-new-202603-outdoor-js","58":"component---src-templates-new-js","59":"component---src-templates-news-js","60":"component---src-templates-order-confirmation-js","61":"component---src-templates-product-js","62":"component---src-templates-productfamily-js","63":"component---src-templates-promo-greenfriday-js","64":"component---src-templates-sale-js","65":"component---src-templates-search-js","66":"component---src-templates-sku-js"}[chunkId]||chunkId) + "-" + {"0":"e554a9f5bad1c5b2721b","1":"29147cbc04bbc833f6a0","4":"46b4173e1060a5c82475","5":"754c56cbfed861598a44","6":"3a44f86397c5190219f0","7":"c20fa4fafe81545de76e","8":"398b2ff08de4be35f08d","9":"7e4c708debe19f637fd4","10":"b4cdc9c07093ad19df7e","11":"b6dda5ee397305e990af","12":"4bb14dc7d2f1f688bb51","13":"839b103927dd7e6e002e","14":"8d17fd89d78ee8636e1a","15":"e7d3504423b8321cc142","16":"d88b44550c7b6ba6b0ad","17":"eee886d7d270a2763da0","18":"e568fd3122b4cb634f23","19":"3d86e0e54e6f630ec143","20":"ea66c2be42844148ca56","21":"8eccbfee586c75a7ac38","22":"1f5390e20e75e32726d6","23":"0fddb3e83ce58415138b","24":"23b5cb1ca88a5f608eef","25":"32451f172fea36d467ee","26":"5f9661d263524e80d276","27":"f321b9d6528585835fef","28":"2db93efdc0930446db5a","29":"cc8bb9af31d3032d1c70","30":"225f0bf6c06085d930da","31":"3d06a8d22ef592c0fb5d","32":"40255a9199e4b8ade9ca","33":"392b87e31d9c8dd241a0","34":"aadb763a846210bde48d","35":"bc5b71cdc5996ef151e4","36":"570186ae69012dbd399a","37":"32b723b5d2e81330ae45","38":"8aff46042e75f1ebca67","39":"224b9d8491c73cabc40a","40":"977a8bc9ffdf40f9967b","41":"6a6569b667d0e003dcde","42":"be41d634fcba7b26d4a4","43":"10cf6cf2decaa1db0c05","44":"b68a3bd6f277b8a03c1c","45":"6f3b0a1784979d75c073","46":"6ce953f8926545ae1bbf","47":"b391c1470b0bc2a28853","48":"30a0bfd04fbb89261c46","49":"705dd4863b78a85a028f","50":"3ee2319253ba904465c1","51":"ec7725bda9b8a57facd1","52":"cbb8b32caf06e84eb641","53":"fd06c4a21d65cc95e667","54":"4bf9677e4783d833e800","55":"1c38ca31b59d836130bf","56":"cd85e6b2ffe94d105de5","57":"e783c5826619203ce450","58":"f4cf50b28834de3c76bd","59":"a7c6808f513c7eaec566","60":"486b4b72c1578d8b2aec","61":"15c9c4697b9810feba14","62":"edbc3cabca06ab2ac956","63":"4b43401aad7bc0b8c377","64":"b89a69c3a19cbe9ef22f","65":"74bb7811af7568c9b6ff","66":"d6de5cfc60e4ffa2e429"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"16b93416ca1bd2e4cb6713ddcd17b49c99505daa","1":"styles","4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-templates-404-js","6":"component---src-templates-account-addresses-js","7":"component---src-templates-account-giftlist-items-js","8":"component---src-templates-account-giftlist-orders-js","9":"component---src-templates-account-giftlists-js","10":"component---src-templates-account-home-js","11":"component---src-templates-account-orders-js","12":"component---src-templates-account-wishlist-js","13":"component---src-templates-actions-202603-haymags-js","14":"component---src-templates-actions-202603-pantonwire-js","15":"component---src-templates-actions-fromme-2023-js","16":"component---src-templates-actions-hay-2023-outdoor-js","17":"component---src-templates-actions-moebe-2023-bed-js","18":"component---src-templates-actions-muuto-2023-dining-js","19":"component---src-templates-actions-pf-2023-js","20":"component---src-templates-actions-showroom-js","21":"component---src-templates-actions-string-2023-elevate-js","22":"component---src-templates-actions-upnorth-5-y-js","23":"component---src-templates-actions-weekend-2023-js","24":"component---src-templates-brands-index-js","25":"component---src-templates-brands-item-js","26":"component---src-templates-cart-js","27":"component---src-templates-category-js","28":"component---src-templates-checkout-giftwrapping-js","29":"component---src-templates-checkout-guest-js","30":"component---src-templates-checkout-index-js","31":"component---src-templates-checkout-payment-js","32":"component---src-templates-checkout-shipping-js","33":"component---src-templates-checkout-status-js","34":"component---src-templates-contact-js","35":"component---src-templates-content-about-js","36":"component---src-templates-content-appointment-js","37":"component---src-templates-content-complaints-js","38":"component---src-templates-content-customer-of-the-month-js","39":"component---src-templates-content-delivery-js","40":"component---src-templates-content-payment-js","41":"component---src-templates-content-privacy-js","42":"component---src-templates-content-returns-js","43":"component---src-templates-content-string-byo-js","44":"component---src-templates-content-team-js","45":"component---src-templates-content-terms-js","46":"component---src-templates-content-testimonials-js","47":"component---src-templates-content-vacatures-js","48":"component---src-templates-content-vacatures-js-developer-js","49":"component---src-templates-createaccount-js","50":"component---src-templates-giftlist-buy-index-js","51":"component---src-templates-giftlist-create-index-js","52":"component---src-templates-giftlist-index-js","53":"component---src-templates-homepage-js","54":"component---src-templates-interioradvice-js","55":"component---src-templates-lostpassword-js","56":"component---src-templates-new-202603-hayterrazza-js","57":"component---src-templates-new-202603-outdoor-js","58":"component---src-templates-new-js","59":"component---src-templates-news-js","60":"component---src-templates-order-confirmation-js","61":"component---src-templates-product-js","62":"component---src-templates-productfamily-js","63":"component---src-templates-promo-greenfriday-js","64":"component---src-templates-sale-js","65":"component---src-templates-search-js","66":"component---src-templates-sku-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"cb3b493475df292fff82","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
